<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<QueryCondition @query="query" @exportExcel="exportExcel" ref="queryCondition" />

			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>

	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/JoinJobQueryCondition'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				queryParams: {},
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '来源',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.jobChannel;
							if (val == '1') {
								name = '兼职猫'
							} else if (val == '2') {
								name = '自营'
							}
							return h('span', name)
						}
					},
					{
						title: 'app',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.appChannel;
							if (val == '1') {
								name = '兼职直聘'
							} else if (val == '2') {
								name = '校园直聘'
							} else if (val == '3') {
								name = '线上日结宅家赚'
							} else if (val == '4') {
								name = '蜗牛兼职'
							} else if (val == '5') {
								name = '支付宝小金豆'
							} else if (val == '6') {
								name = '大熊兼职商家版'
							} else if (val == '7') {
								name = '大熊兼职'
							}else if (val == '8') {
								name = '米罐兼职'
							}
							return h('span', name)
						}
					},
					{
						title: '报名ID',
						width: 200,
						key: 'applyId',
						align: 'center'
					},
					{
						title: '用户ID',
						key: 'userId',
						align: 'center',
						width: 200,
					},
					{
						title: '用户名',
						key: 'userName',
						align: 'center',
						width: 100,
					},
					{
						title: '手机号',
						key: 'mobile',
						align: 'center',
						width: 100,
					},
					{
						title: '推广主渠道',
						key: 'mainChannelCode',
						align: 'center',
						width: 150,
					}, {
						title: '推广子渠道',
						key: 'childChannelCode',
						align: 'center',
						width: 150,
					},
					{
						title: '市场渠道',
						key: 'storeChannel',
						align: 'center',
						width: 100,
					},
					{
						title: '报名岗位',
						key: 'jobName',
						align: 'center',
						width: 200,
					},
					{
						title: '公司',
						key: 'company',
						align: 'center',
						width: 200,
					},
					{
						title: '状态',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.status;
							if (val == '0') {
								name = '待录取'
							} else if (val == '1') {
								name = '已录取'
							} else if (val == '2') {
								name = '已完成工作'
							} else if (val == '3') {
								name = '已拒绝'
							} else if (val == '4') {
								name = '已拒绝'
							} else {
								name = '失败'
							}
							return h('span', name)
						}
					}, {
						title: '报名日期',
						key: 'createTime',
						align: 'center',
						width: 200,
					}, {
						title: '失败原因',
						key: 'remark',
						align: 'center',
						width: 200,
					}

				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.joinJobPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			//导出数据
			exportExcel() {
				const that = this
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.exportJoin(queryParams)
					.then(res => {
						that.util.excel(res, "报名数据")
					})
			}
		}

	}
</script>